import dayjs from 'dayjs';
import { ManifestApiModel, ManifestCanCompleteType } from '~/lib/api/smartsend/types';
import { ToManifestDateObj } from './ToManifestDate';

export function ManifestCanBeCompleted(m: ManifestApiModel): boolean {
  return ManifestCanBeCompleteStatus(m) == 'MANIFESTABLE';
}

export const ManifestIsEditable = (s: ManifestCanCompleteType | undefined) =>
  s && ['MANIFESTABLE', 'CUTOFF-MISSED', 'FUTURE', 'PAST'].includes(s);

export function ManifestCanBeCompleteStatus(m: ManifestApiModel): ManifestCanCompleteType {
  if (m.Status == 'PROCESSING') {
    return 'PROCESSING';
  }

  if (m.Status != 'DRAFT') {
    return 'COMPLETED';
  }

  if (!m.ManifestOrderLines || m.ManifestOrderLines.length == 0) {
    return 'NOITEMS';
  }

  const forDate = ToManifestDateObj(m.ForDate);
  const now = dayjs();

  if (forDate?.isAfter(now, 'date')) {
    return 'FUTURE';
  }

  if (forDate?.isBefore(now, 'date')) {
    return 'PAST';
  }
  if (m.ManifestBy?.Hour !== undefined && m.ManifestBy?.Minute !== undefined) {
    const cutoff = dayjs().hour(m.ManifestBy.Hour).minute(m.ManifestBy.Minute);
    if (now.isAfter(cutoff)) {
      return 'CUTOFF-MISSED';
    }
  }

  return 'MANIFESTABLE';
}
export function ManifestCountDown(m: ManifestApiModel): number | null {
  const status = ManifestCanBeCompleteStatus(m);
  if (status !== 'MANIFESTABLE' || m.ManifestBy?.Hour == undefined || m.ManifestBy?.Minute == undefined) {
    return null;
  }
  const now = dayjs();
  const cutoff = dayjs().hour(m.ManifestBy.Hour).minute(m.ManifestBy.Minute);
  return cutoff.diff(now, 'minutes');
}
